import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/css';
import 'slick-carousel/slick/slick.css';
import './sass/index.scss';
import { SnackbarProvider } from './components/Providers/SnackbarProvider';
import { ThemeProvider } from '@emotion/react';
import { CategoriesProvider } from './components/Providers/CategoryContext';
import { AuthProvider } from './context/AuthContext';

export const themeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#5625d8',
    },
    secondary: {
      main: '#f50057',
    },
    text: {
      primary: 'rgba(239,235,235,0.87)',
    },
  },
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <SnackbarProvider>
            <CategoriesProvider>
              <ThemeProvider theme={themeOptions}>
                <App />
              </ThemeProvider>
            </CategoriesProvider>
          </SnackbarProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
